export const POLLS_API = process.env.REACT_APP_POLLS_API || "https://polls.racevision.info";

export function adminAuthHeader() {
    const token =
        localStorage.getItem("rv_token") ||
        localStorage.getItem("access_token") ||
        "";
    return token ? { Authorization: `Bearer ${token}` } : {};
}

// anonyme ID pro Browser (für Dedup)
export function getOrCreateAnonId() {
    let id = localStorage.getItem("rv_polls_anon_id");
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("rv_polls_anon_id", id);
    }
    return id;
}

// roomCode via ?code=gt3x-r1
export function getRoomCodeFromQuery() {
    const p = new URLSearchParams(window.location.search);
    return (p.get("code") || "").trim();
}